<script>
  import api from '$lib/api.js';
  import PageHeader from '../../components/PageHeader.svelte';
  import DataTable from '../../components/DataTable.svelte';
  import Pagination from '../../components/Pagination.svelte';

  let loading = $state(true);
  let error = $state(null);
  let items = $state([]);
  let pagination = $state(null);
  let page = $state(1);

  $effect(() => {
    page;
    (async () => {
      loading = true;
      error = null;
      try {
        const result = await api.listAudit({ page, limit: 50 });
        items = result.items;
        pagination = result.pagination;
      } catch (e) {
        error = e.message;
      } finally {
        loading = false;
      }
    })();
  });

  const columns = [
    { key: 'created_at', label: 'When', render: (r) => new Date(r.created_at).toLocaleString() },
    { key: 'user_email', label: 'Who', render: (r) => r.user_email ?? '—' },
    { key: 'action', label: 'Action', render: (r) => r.action.replace(/_/g, ' ') },
    {
      key: 'resource_type', label: 'Resource',
      render: (r) => (r.resource_id ? `${r.resource_type} #${r.resource_id}` : r.resource_type),
    },
    {
      key: 'changes', label: 'Details',
      render: (r) => (r.changes ? JSON.stringify(r.changes) : '—'),
    },
  ];
</script>

<PageHeader title="Audit log" subtitle="Every change made through the portal." />

{#if error}
  <p class="p-card p-4 text-sm" style="color: var(--p-danger)">{error}</p>
{:else}
  <DataTable {columns} rows={items} {loading} emptyMessage="No portal changes recorded yet." />
  <Pagination {pagination} onPage={(p) => (page = p)} />
{/if}
